import React, { useState } from "react";
import { Group } from '@mantine/core';
import { BASEURL } from "../../helpers/url_helper";
import MantineImage from "../../components/mantine/image";
import MantineText from "../../components/mantine/text";
import ActionMenu from '../../pages/managesites/manual/actionMenu';
import ActionMenuBySiteId from '../../pages/manuals/actionMenu';
interface ManualCardProps {
    number: any
    manualname:any
    virginImage: any;
    jbAssociateImage: any;
    doorImage: any;
    arrowImage: any;
    showedit: boolean;
    showdownload: boolean;
    handleEdit?: (item: any) => void;
    handleDelete?: (item: any) => void;
    handleView?: (item: any) => void;
   
    item?: any;

}

const ManualCard: React.FC<ManualCardProps> = ({ number, manualname, virginImage, jbAssociateImage, doorImage, arrowImage, showedit, showdownload,handleEdit, handleDelete, item }) => { 
    const [selectedRows, setSelectedRows] = useState<any>([]);
    const handleItemClick = () => {
        if (item && item.url) {
            window.open(item.url, "_blank");
        }
    };
    const handleMenuClick = (event: React.MouseEvent) => {
        event.stopPropagation(); 
    };  
    return (
        <div className='w-[369px] h-[370px] bg-white border rounded-[5px]' onClick={handleItemClick}>
            <Group className='flex flex-row items-center p-4'>
                <MantineImage src={`${BASEURL}/Client/GetImage?fileName=${item.logo}`} alt="img-virgin" className='w-[50px] h-[24px] mb-4 opacity-100' />

                {/* <MantineText className="w-[69px] h-[69px] font-semibold text-[#041E42] text-[53px] leading-[64px] rounded-full bg-[#F7F7F7] flex items-center justify-center"
                    style={{ marginLeft: 'auto' }}>
                    {number}
                </MantineText> */}

                <MantineImage src={jbAssociateImage}
                    alt="img-jb-associate" className='w-[96px] h-[21px] opacity-100'
                    style={{ marginLeft: 'auto' }} />

                {showedit && (
                    <div onClick={handleMenuClick}>
                        <ActionMenu handleEdit={handleEdit} handleDelete={handleDelete} setSelectedRows={setSelectedRows} item={item} />
                    </div>
                )}
                
                {showdownload && (
                    <div onClick={handleMenuClick}>
                        <ActionMenuBySiteId  setSelectedRows={setSelectedRows} item={item} />
                    </div>
                )}
                <MantineText
                    className="w-[398px] h-[16px]  mb-4 font-bold text-[13px] leading-[16px] text-[rgb(4,30,66)] flex items-center justify-center">
                 {manualname} 
                </MantineText>

                {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <MantineImage src={arrowImage} alt="img-dark-arrow" className="w-[34px] h-[34px] mb-4 opacity-100" />
                    {/* <MantineText className="w-[134px] h-[34px] mb-4 font-semibold text-[28px] leading-[35px] text-[#F86969]">EXAMPLE</MantineText> 
                </div> */}

            </Group>
            <MantineImage src={doorImage} alt="img-door" className='w-[369px] h-[210px] opacity-100' />
            
            <MantineImage
                src={arrowImage}
                alt="img-dark-arrow-small"
                className='w-[20px] h-[20px] mt-2 opacity-100'
                style={{ marginLeft: 'auto' }}
            />
        </div>
    );
};


export default ManualCard;
